let isQz = true;
let printWindow = null;

exports.impressaoCompleta = async function(pedido, tamanho) {
  const filters = window.getApp.$root.$options.filters;
  const dayjs = window.getApp.$dayjs;
  let previsao = '';
  let itensPedido = '';
  let taxaEntrega = '';
  let taxaServico = '';
  let cupomDesconto = '';
  let trocoPedido = '';
  let obsevacaoPedido = '';
  let referencia = '';
  let stylePequeno = '';

  function toUpper(txt) {
    return txt ? filters.removeAccents(txt).toUpperCase() : "";
  }

  if (pedido.status != 3 && pedido.status != 0 && pedido.tempo_entrega) {
    const lbPrevisao = pedido.endereco.id == -1 ? 'PREVISAO DE RETIRADA: ' : 'PREVISAO DE ENTREGA: ';
    const tempo = dayjs(pedido.data).add(pedido.tempo_entrega, 'minutes').format('DD/MM/YYYY - HH:mm');
    previsao = `<strong>${lbPrevisao}</strong>${tempo}`;
  }

  const isCardapioDigital = pedido.cardapio_digital == 1;

  itensPedido = `<table style="width: 100%; border-collapse: collapse; border-spacing: 0;">`;

  for (let i in pedido.itens) {
    const item = pedido.itens[i];

    itensPedido += `
      <tr style="width: 100%;">
        <td style="border: none;" align="left" valign="top">
          <h6 style="margin: 0; font-weight: 400;">${item.quantidade}x&nbsp;</h6>
        </td>
        <td style="border: none;" id="minValue" align="left" valign="top">
          <h6 style="margin: 0; font-weight: 400; white-space: normal;">
            <strong>${toUpper(item.item.categoria)}:</strong> ${toUpper(item.item.nome)}
          </h6>
        </td>
        <td style="border: none;" align="right" valign="top">
          <h6 style="margin: 0; font-weight: 400; white-space: nowrap;">
            ${filters.currency((item.preco_base * item.quantidade), 'R$', 2)}
          </h6>
        </td>
      </tr>`;

    if (item.variacoes.length) {
      for (let j in item.variacoes) {
        const variacao = item.variacoes[j];

        itensPedido += `
          <tr style="width: 100%;">
            <td style="border: none;" align="right" valign="top">
              <h6 style="margin: 0; font-weight: 400;">-</h6>
            </td>
            <td style="border: none;" id="minValue" align="left" valign="top">
              <h6 style="margin: 0 !important; font-weight: 400;">
                <strong>${toUpper(variacao.variacao.nome)}:</strong> ${toUpper(variacao.item.nome)}
              </h6>
            </td>
            <td style="border: none;" align="right" valign="top">
              <h6 style="margin: 0; font-weight: 400; white-space: nowrap;">
                ${(variacao.mod_preco == 1 && variacao.preco > 0) ? filters.currency(variacao.preco * item.quantidade, 'R$', 2) : ''}
              </h6>
            </td>
          </tr>`;
      }
    }

    if (item.observacao) {
      itensPedido += `
        <tr style="width: 100%;">
          <td colspan="3" align="left" valign="middle" style="max-width: 100%; border: none;">
            <h6 style="margin: 0; font-weight: 400;">
              <strong>OBS.:</strong> ${toUpper(item.observacao)}
            </h6>
          </td>
        </tr>`;
    }

    if (pedido.itens.length > 1) {
      itensPedido += `
        <tr style="width: 100%; height: 0.1cm;">
          <td colspan="3" style="border: none;">&nbsp;</td>
        </tr>`;
    }
  }

  itensPedido += `</table>`;

  if (pedido.endereco_id > 0) {
    taxaEntrega += `
      <tr style="width: 100%">
        <td colspan="2" align="left" valign="middle" style="width: 80%"><h6 style="margin: 0;font-weight: 400;"><strong>TAXA DE ENTREGA:</strong></h6></td>
        <td align="right" valign="middle" style="width: 20%"><h6 style="margin: 0;font-weight: 400;white-space: nowrap;">${filters.currency(pedido.taxa_entrega, 'R$', 2)}</h6></td>
      </tr>`;
  }

  if (pedido.endereco.referencia) {
    referencia += `
      <tr style="width: 100%">
        <td colspan="3" align="left" valign="middle" style="width: 100%"><h6 style="margin: 0;font-weight: 400;word-break: break-word;"><strong>REFERENCIA: </strong>${toUpper(pedido.endereco.referencia)}</h6></td>
      </tr>`;
  }

  if (pedido.taxa_servico) {
    taxaServico += `
      <tr style="width: 100%">
        <td colspan="2" align="left" valign="middle" style="width: 80%"><h6 style="margin: 0;font-weight: 400;"><strong>TAXA DE SERVICO:</strong></h6></td>
        <td align="right" valign="middle" style="width: 20%"><h6 style="margin: 0;font-weight: 400;white-space: nowrap;">${filters.currency(pedido.taxa_servico, 'R$', 2)}</h6></td>
      </tr>`;
  }

  if (pedido.cupom_desconto_id) {
    cupomDesconto += `
      <tr style="width: 100%">
        <td colspan="2" align="left" valign="middle" style="width: 80%"><h6 style="margin: 0;font-weight: 400;"><strong>CUPOM DESCONTO:</strong></h6></td>
        <td align="right" valign="middle" style="width: 20%"><h6 style="margin: 0;font-weight: 400;white-space: nowrap;"> -${filters.currency(pedido.desconto, 'R$', 2)}</h6></td>
      </tr>`;
  }

  if (pedido.troco) {
    trocoPedido += `
      <tr style="width: 100%">
        <td colspan="2" align="left" valign="middle" style="width: 80%"><h6 style="margin: 0;font-weight: 400;"><strong>PAGAMENTO:</strong></h6></td>
        <td align="right" valign="middle" style="width: 20%"><h6 style="margin: 0;font-weight: 400;white-space: nowrap;">${filters.currency(pedido.troco, 'R$', 2)}</h6></td>
      </tr>
      <tr style="width: 100%">
        <td colspan="2" align="left" valign="middle" style="width: 80%"><h6 style="margin: 0;font-weight: 400;"><strong>TROCO:</strong></h6></td>
        <td align="right" valign="middle" style="width: 20%"><h6 style="margin: 0;font-weight: 400;white-space: nowrap;">${filters.currency(pedido.troco - pedido.total, 'R$', 2)}</h6></td>
      </tr>`;
  }

  if (pedido.observacao && pedido.observacao.length > 0) {
    obsevacaoPedido += `
      <tr style="width: 100%">
        <td colspan="3" align="center" valign="middle" style="width: 100%; border-top: 1px solid #000000; border-bottom: 1px solid #000000;"><h5 style="margin: 0;"><strong>OBSERVACAO DO PEDIDO</strong></h5></td>
      </tr>
      <tr style="width: 100%">
        <td colspan="3" align="left" valign="middle" style="width: 100%"><h6 style="margin: 0;font-weight: 400;word-break: break-word;">${toUpper(pedido.observacao)}</h6></td>
      </tr>`;
  }

  if (tamanho && tamanho == 1 && isQz) {
    stylePequeno = `
      <head>
        <style type="text/css" media="print">
          @page { size: auto; margin: 0mm 2mm 0mm 0mm; }
          body { margin: 0mm; padding: 0mm; box-sizing: border-box; }
          body, table { font-family: Consolas, sans-serif; font-weight: 400; width: 72mm; font-size: 13px!important; }
          #minValue { min-width: 48mm !important }
          tr, td { border: 0.3px solid #FFFFFF; }
        </style>
        <style type="text/css">
          body, table tbody { font-size: small!important; }
        </style>
      </head>`;
  } else if (tamanho && tamanho == 2 && isQz) {
    stylePequeno = `
      <head>
        <style type="text/css" media="print">
          @page { size: auto; margin: 0mm 2mm 2mm 0mm; }
          body { margin: 0mm; padding: 0mm; box-sizing: border-box; }
          body, table { font-family: Consolas, sans-serif; width: 72mm; font-size: 14pxpx!important; }
          tr, td { border: 0.3px solid #FFFFFF; }
        </style>
      </head>`;
  } else {
    stylePequeno = `
      <head>
        <style type="text/css" media="print">
          h6 { font-size: 13px; font-weight: 500!important; }
          @page { size: auto; margin: 0mm 0mm 0mm 0mm; }
          body { margin: 0mm; padding: 0mm; box-sizing: border-box; }
          body, table { font-family: Consolas, sans-serif; font-weight: 500; width: 72mm; }
        </style>
      </head>`;
  }

  const html = `
    <html style="font-family: Consolas; font-weight: 400;">
      ${stylePequeno}
      <table style="width: 100%;" border="0">
        <tr style="width: 100%; height: auto;">
          <td colspan="3" align="center" valign="middle"><h2 style="margin: 0; padding: 0;">${isCardapioDigital ? 'CARDÁPIO DIGITAL' : 'BIGOU DELIVERY'}</h2></td>
        </tr>
        <tr style="width: 100%">
          <td colspan="3" align="left" valign="middle" style="width: 100%"><h6 style="margin: 0;font-weight: 400;word-break: break-word;"><strong>FORNECEDOR: </strong>${toUpper(pedido.estabelecimento.nome)}</h6></td>
        </tr>
        <tr style="width: 100%">
          <td colspan="3" align="left" valign="middle" style="width: 100%"><h6 style="margin: 0;font-weight: 400;"><b>PEDIDO: ${pedido.id}</strong></h6></td>
        </tr>
        <tr style="width: 100%">
          <td colspan="3" align="left" valign="middle" style="width: 100%"><h6 style="margin: 0;font-weight: 400;"><strong>DATA: </strong>${dayjs(pedido.data).format('DD/MM/YYYY - HH:mm')}</h6></td>
        </tr>
        <tr style="width: 100%">
          <td colspan="3" align="left" valign="middle" style="width: 100%"><h6 style="margin: 0;font-weight: 400;word-break: break-word!important;">${previsao}</h6></td>
        </tr>
        <tr style="width: 100%">
          <td colspan="3" align="center" valign="middle" style="width: 100%; border-top: 1px solid #000000; border-bottom: 1px solid #000000;"><h5 style="margin: 0;"><strong>DADOS DA ENTREGA</strong></h5></td>
        </tr>
        <tr style="width: 100%">
          <td colspan="3" align="left" valign="middle" style="width: 100%"><h6 style="margin: 0;font-weight: 400;word-break: break-word;"><strong>CLIENTE: </strong>${toUpper(pedido.usuario.nome)}</h6></td>
        </tr>
        <tr style="width: 100%">
          <td colspan="3" align="left" valign="middle" style="width: 100%"><h6 style="margin: 0;font-weight: 400;word-break: break-word;"><strong>TELEFONE: </strong>${filters.telefone(pedido)}</h6></td>
        </tr>
        <tr style="width: 100%">
          <td colspan="3" align="left" valign="middle" style="width: 100%"><h6 style="margin: 0;font-weight: 400;word-break: break-word;"><strong>ENDERECO: </strong>${toUpper(filters.endereco(pedido.endereco))}</h6></td>
        </tr>
        ${referencia}
        <tr style="width: 100%; height: auto;">
          <td colspan="3" align="center" valign="middle" style="width: 100%; border-top: 1px solid #000000; border-bottom: 1px solid #000000;"><h5 style="margin: 0;"><strong>ITENS DO PEDIDO</strong></h5></td>
        </tr>
      </table>
      ${itensPedido}
      <table style="width: 100%;" border="0">
        ${obsevacaoPedido}
        <tr style="width: 100%">
          <td colspan="3" align="center" valign="middle" style="width: 100%; border-top: 1px solid #000000; border-bottom: 1px solid #000000;"><h5 style="margin: 0;"><strong>PAGAMENTO</strong></h5></td>
        </tr>
        <tr style="width: 100%">
          <td colspan="2" align="left" valign="middle" style="width: 80%"><h6 style="margin: 0;font-weight: 400;"><strong>SUBTOTAL:</strong></h6></td>
          <td align="right" valign="middle" style="width: 20%"><h6 style="margin: 0;font-weight: 400;white-space: nowrap;">${filters.currency(pedido.subtotal, 'R$', 2)}</h6></td>
        </tr>
        ${taxaEntrega}
        ${taxaServico}
        ${cupomDesconto}
        <tr style="width: 100%">
          <td colspan="2" align="left" valign="middle" style="width: 80%"><h6 style="margin: 0;"><strong>TOTAL:</strong></h6></td>
          <td align="right" valign="middle" style="width: 20%"><h6 style="margin: 0;font-weight: 400;white-space: nowrap;"><strong>${filters.currency(pedido.total, 'R$', 2)}</strong></h6></td>
        </tr>
        <tr style="width: 100%">
          <td colspan="2" align="left" valign="top" style="width: 60%"><h6 style="margin: 0;font-weight: 400;"><strong>FORMA DE PAGAMENTO:</strong></h6></td>
          <td align="right" valign="middle" style="width: 40%"><h6 style="margin: 0;font-weight: 400;">${toUpper(pedido.formaPagamento.nome)}</h6></td>
        </tr>
        ${trocoPedido}
        <tr style="width: 100%; border-bottom: 1px solid #000000;"><td colspan="3">&nbsp</td></tr>
        <tr style="width: 100%">
          <td colspan="3" align="center" valign="middle" style="width: 100%;"><h5 style="margin: 0;"><strong>CUPOM NAO FISCAL</strong></h5></td>
        </tr>
        <tr style="width: 100%">
          <td colspan="3" align="center" valign="middle" style="width: 100%;"><h5>${isCardapioDigital ? '' : 'www.bigou.com.br'}</h5></td>
        </tr>
      </table>
      </body>
    </html>`;

  return html;
};

exports.impressaoLimpa = async function(pedido, tamanho) {
  const filters = window.getApp.$root.$options.filters;
  const dayjs = window.getApp.$dayjs;
  let previsao = '';
  let itensPedido = '';
  let taxaServico = '';
  let taxaEntrega = '';
  let cupomDesconto = '';
  let trocoPedido = '';
  let obsevacaoPedido = '';
  let referencia = '';
  let stylePequeno = '';

  function toUpper(txt) {
    return txt ? filters.removeAccents(txt).toUpperCase() : "";
  }

  const isCardapioDigital = pedido.cardapio_digital == 1;

  if (pedido.status != 3 && pedido.status != 0 && pedido.tempo_entrega) {
    const lbPrevisao = pedido.endereco.id == -1 ? 'PREVISAO DE RETIRADA: ' : 'PREVISAO DE ENTREGA: ';
    const tempo = dayjs(pedido.data).add(pedido.tempo_entrega, 'minutes').format('DD/MM/YYYY - HH:mm');
    previsao = `<strong>${lbPrevisao}</strong>${tempo}`;
  }

  itensPedido += `<table style="width: 100%;border: none; border-collapse:collapse; border-spacing: 0;" border="1">`;

  pedido.itens.map((itemPedido) => {
    itensPedido += `
      <tr style="width: 100%; border: none;">
        <td style="border: none;" align="left" valign="top" style="max-width: 20%"><h6 style="margin: 0;font-weight: 400;white-space: nowrap;">${itemPedido.quantidade}x &nbsp;</h6></td>
        <td style="border: none;" align="left" valign="top" style="max-width: 50%;">
          <h6 style="margin: 0;font-weight: 400;"><strong>${toUpper(itemPedido.item.nome)}</strong></h6>${itemPedido.item.cod_bar ? `<br><small>CÓDIGO: ${itemPedido.item.cod_bar}</small>` : ''}
        </td>
        <td style="border: none;" align="right" valign="top" style="max-width: 30%"><h6 style="margin: 0;font-weight: 400;white-space: nowrap;">${filters.currency((itemPedido.preco_base), 'R$', 2)}</h6></td>
      </tr>`;

    if (!!itemPedido.variacoes) {
      const variacoesOrdenadas = this.variacoes(itemPedido.variacoes).sort((a, b) => {
        if (a.indice !== b.indice) return a.indice - b.indice;
        if (a.variacao !== b.variacao) return a.variacao.localeCompare(b.variacao);
        return a.nome.localeCompare(b.nome);
      });

      variacoesOrdenadas.forEach((itemVariacao) => {
        itensPedido += `
          <tr style="width: 100%;border: none;">
            <td style="border: none;" align="right" valign="top" style="max-width: 20%"><h6 style="margin: 0;font-weight: 400;white-space: nowrap;">${itemVariacao.quantidade}x </h6></td>
            <td style="border: none;" align="left" valign="top" style="max-width: 50%"><h6 style="margin: 0;font-weight: 400;"><strong>${filters.removeAccents(itemVariacao.nome).toUpperCase()}</strong></h6></td>
            <td style="border: none;" align="right" valign="top" style="max-width: 30%"><h6 style="margin: 0;font-weight: 400;white-space: nowrap;">${itemVariacao.mod_preco == 1 && itemVariacao.preco > 0 ? `+ ${filters.currency(itemVariacao.preco)}` : ''}</h6></td>
          </tr>`;
      });
    }

    if (itemPedido.observacao) {
      itensPedido += `
        <tr style="width: 100%;border: none;">
          <td colspan="3" align="left" valign="middle" style="max-width: 100%; border: none;"><h6 style="margin: 0;font-weight: 400;"><strong>OBS.: </strong>${toUpper(itemPedido.observacao)}</h6></td>
        </tr>`;
    }

    if (pedido.itens.length > 1) {
      itensPedido += `<tr style="width: 100%;border: none; height: 0.1cm"><td colspan="3" style="border: none;">&nbsp;</td></tr>`;
    }
  });

  itensPedido += `</table>`;

  if (pedido.endereco_id > 0) {
    taxaEntrega += `
      <tr style="width: 100%">
        <td colspan="2" align="left" valign="middle" style="width: 80%"><h6 style="margin: 0;font-weight: 400;"><strong>TAXA DE ENTREGA:</strong></h6></td>
        <td align="right" valign="middle" style="width: 20%"><h6 style="margin: 0;font-weight: 400;">${filters.currency(pedido.taxa_entrega, 'R$', 2)}</h6></td>
      </tr>`;
  }

  if (pedido.endereco.referencia) {
    referencia += `
      <tr style="width: 100%">
        <td colspan="3" align="left" valign="middle" style="width: 100%"><h6 style="margin: 0;font-weight: 400;word-break: break-word;"><strong>REFERENCIA: </strong>${toUpper(pedido.endereco.referencia)}</h6></td>
      </tr>`;
  }

  if (pedido.taxa_servico) {
    taxaServico += `
      <tr style="width: 100%">
        <td colspan="2" align="left" valign="middle" style="width: 80%"><h6 style="margin: 0;font-weight: 400;"><strong>TAXA DE SERVICO:</strong></h6></td>
        <td align="right" valign="middle" style="width: 20%"><h6 style="margin: 0;font-weight: 400;white-space: nowrap;">${filters.currency(pedido.taxa_servico, 'R$', 2)}</h6></td>
      </tr>`;
  }

  if (pedido.cupom_desconto_id) {
    cupomDesconto += `
      <tr style="width: 100%">
        <td colspan="2" align="left" valign="middle" style="width: 80%"><h6 style="margin: 0;font-weight: 400;"><strong>CUPOM DESCONTO:</strong></h6></td>
        <td align="right" valign="middle" style="width: 20%"><h6 style="margin: 0;font-weight: 400;"> -${filters.currency(pedido.desconto, 'R$', 2)}</h6></td>
      </tr>`;
  }

  if (pedido.troco) {
    trocoPedido += `
      <tr style="width: 100%">
        <td colspan="2" align="left" valign="middle" style="width: 80%"><h6 style="margin: 0;font-weight: 400;"><strong>PAGAMENTO:</strong></h6></td>
        <td align="right" valign="middle" style="width: 20%"><h6 style="margin: 0;font-weight: 400;">${filters.currency(pedido.troco, 'R$', 2)}</h6></td>
      </tr>
      <tr style="width: 100%">
        <td colspan="2" align="left" valign="middle" style="width: 80%"><h6 style="margin: 0;font-weight: 400;"><strong>TROCO:</strong></h6></td>
        <td align="right" valign="middle" style="width: 20%"><h6 style="margin: 0;font-weight: 400;">${filters.currency(pedido.troco - pedido.total, 'R$', 2)}</h6></td>
      </tr>`;
  }

  if (pedido.observacao && pedido.observacao.length > 0) {
    obsevacaoPedido += `
      <tr style="width: 100%">
        <td colspan="3" align="center" valign="middle" style="width: 100%; border-top: 1px solid #000000; border-bottom: 1px solid #000000;"><h5 style="margin: 0;"><strong>OBSERVACAO DO PEDIDO</strong></h5></td>
      </tr>
      <tr style="width: 100%">
        <td colspan="3" align="left" valign="middle" style="width: 100%"><h6 style="margin: 0;font-weight: 400;word-break: break-word;">${toUpper(pedido.observacao)}</h6></td>
      </tr>`;
  }

  if (tamanho && tamanho == 1 && isQz) {
    stylePequeno = `
      <head>
        <style type="text/css" media="print">
          @page { size: auto; margin: 0mm 2mm 0mm 0mm; }
          body, table { font-family: Consolas, sans-serif; width: 72mm; font-size: 13px!important; }
        </style>
        <style type="text/css">
          body, table tbody { font-size: small!important; }
        </style>
      </head>`;
  } else if (tamanho && tamanho == 2 && isQz) {
    stylePequeno = `
      <head>
        <style type="text/css" media="print">
          @page { size: auto; margin: 0mm 2mm 2mm 0mm; }
          body, table { font-family: Consolas, sans-serif; width: 72mm; font-size: 14pxpx!important; }
        </style>
      </head>`;
  } else {
    stylePequeno = `
      <head>
        <style type="text/css" media="print">
          h6 { font-size: 13px; font-weight: 500!important; }
          @page { size: auto; margin: 0mm 0mm 0mm 0mm; }
          body { margin: 0mm; padding: 0mm; box-sizing: border-box; }
          body, table { font-family: Consolas, sans-serif; font-weight: 500; width: 72mm; }
        </style>
      </head>`;
  }

  const html = `
    <html style="font-family: Consolas;">
      ${stylePequeno}
      <table style="width: 100%;" border="0">
        <tr style="width: 100%; height: auto;">
          <td colspan="3" align="center" valign="middle"><h2 style="margin: 0; padding: 0;"> ${isCardapioDigital ? 'CARDÁPIO DIGITAL' : 'BIGOU DELIVERY'} </h2></td>
        </tr>
        <tr style="width: 100%">
          <td colspan="3" align="left" valign="middle" style="width: 100%"><h6 style="margin: 0;font-weight: 400;word-break: break-word;"><strong>FORNECEDOR: </strong>${toUpper(pedido.estabelecimento.nome)}</h6></td>
        </tr>
        <tr style="width: 100%">
          <td colspan="3" align="left" valign="middle" style="width: 100%"><h6 style="margin: 0;font-weight: 400;"><b>PEDIDO: ${pedido.id}</strong></h6></td>
        </tr>
        <tr style="width: 100%">
          <td colspan="3" align="left" valign="middle" style="width: 100%"><h6 style="margin: 0;font-weight: 400;"><strong>DATA: </strong>${dayjs(pedido.data).format('DD/MM/YYYY - HH:mm')}</h6></td>
        </tr>
        <tr style="width: 100%">
          <td colspan="3" align="left" valign="middle" style="width: 100%"><h6 style="margin: 0;font-weight: 400;word-break: break-word!important;">${previsao}</h6></td>
        </tr>
        <tr style="width: 100%">
          <td colspan="3" align="center" valign="middle" style="width: 100%; border-top: 1px solid #000000; border-bottom: 1px solid #000000;"><h5 style="margin: 0;"><strong>DADOS DA ENTREGA</strong></h5></td>
        </tr>
        <tr style="width: 100%">
          <td colspan="3" align="left" valign="middle" style="width: 100%"><h6 style="margin: 0;font-weight: 400;word-break: break-word;"><strong>CLIENTE: </strong>${toUpper(pedido.usuario.nome)}</h6></td>
        </tr>
        <tr style="width: 100%">
          <td colspan="3" align="left" valign="middle" style="width: 100%"><h6 style="margin: 0;font-weight: 400;word-break: break-word;"><strong>TELEFONE: </strong>${filters.telefone(pedido)}</h6></td>
        </tr>
        <tr style="width: 100%">
          <td colspan="3" align="left" valign="middle" style="width: 100%"><h6 style="margin: 0;font-weight: 400;word-break: break-word;"><strong>ENDERECO: </strong>${toUpper(filters.endereco(pedido.endereco))}</h6></td>
        </tr>
        ${referencia}
        <tr style="width: 100%; height: auto;">
          <td colspan="3" align="center" valign="middle" style="width: 100%; border-top: 1px solid #000000; border-bottom: 1px solid #000000;"><h5 style="margin: 0;"><strong>ITENS DO PEDIDO</strong></h5></td>
        </tr>
      </table>
      ${itensPedido}
      <table style="width: 100%;" border="0">
        ${obsevacaoPedido}
        <tr style="width: 100%">
          <td colspan="3" align="center" valign="middle" style="width: 100%; border-top: 1px solid #000000; border-bottom: 1px solid #000000;"><h5 style="margin: 0;"><strong>PAGAMENTO</strong></h5></td>
        </tr>
        <tr style="width: 100%">
          <td colspan="2" align="left" valign="middle" style="width: 80%"><h6 style="margin: 0;font-weight: 400;"><strong>SUBTOTAL:</strong></h6></td>
          <td align="right" valign="middle" style="width: 20%"><h6 style="margin: 0;font-weight: 400;">${filters.currency(pedido.subtotal, 'R$', 2)}</h6></td>
        </tr>
        ${taxaEntrega}
        ${taxaServico}
        ${cupomDesconto}
        <tr style="width: 100%">
          <td colspan="2" align="left" valign="middle" style="width: 80%"><h6 style="margin: 0;font-weight: 400;"><strong>TOTAL:</strong></h6></td>
          <td align="right" valign="middle" style="width: 20%"><h6 style="margin: 0;font-weight: 400;"><strong>${filters.currency(pedido.total, 'R$', 2)}</strong></h6></td>
        </tr>
        <tr style="width: 100%">
          <td colspan="2" align="left" valign="top" style="width: 60%"><h6 style="margin: 0;font-weight: 400;"><strong>FORMA DE PAGAMENTO:</strong></h6></td>
          <td align="right" valign="middle" style="width: 40%"><h6 style="margin: 0;font-weight: 400;">${toUpper(pedido.formaPagamento.nome)}</h6></td>
        </tr>
        ${trocoPedido}
        <tr style="width: 100%; border-bottom: 1px solid #000000;"><td colspan="3">&nbsp</td></tr>
        <tr style="width: 100%">
          <td colspan="3" align="center" valign="middle" style="width: 100%;"><h5 style="margin: 0;"><strong>CUPOM NAO FISCAL</strong></h5></td>
        </tr>
        <tr style="width: 100%">
          <td colspan="3" align="center" valign="middle" style="width: 100%;"><h5>${isCardapioDigital ? '' : 'www.bigou.com.br'}</h5></td>
        </tr>
        <tr style="width: 100%"><td colspan="3">&nbsp</td></tr>
      </table>
    </html>`;

  return html;
};

exports.impressaoSimplificada = async function(pedido, tamanho) {
  const filters = window.getApp.$root.$options.filters;
  let itensPedido = '';
  let obsevacaoPedido = '';
  let stylePequeno = '';

  function toUpper(txt) {
    return txt ? filters.removeAccents(txt).toUpperCase() : "";
  }

  const isCardapioDigital = pedido.cardapio_digital == 1;

  itensPedido += `<table style="width: 100%;border: none; border-collapse:collapse; border-spacing: 0;" border="1">`;

  pedido.itens.map((itemPedido) => {
    itensPedido += `
      <tr style="width: 100%; border: none;">
        <td style="border: none;" align="left" valign="top" style="max-width: 20%"><h6 style="margin: 0;font-weight: 400;white-space: nowrap;">${itemPedido.quantidade}x &nbsp;</h6></td>
        <td style="border: none;" align="left" valign="top" style="max-width: 50%;">
          <h6 style="margin: 0;font-weight: 400;"><strong>${toUpper(itemPedido.item.nome)}</strong></h6>${itemPedido.item.cod_bar ? `<br><small>CÓDIGO: ${itemPedido.item.cod_bar}</small>` : ''}
        </td>
      </tr>`;

    if (!!itemPedido.variacoes) {
      const variacoesOrdenadas = this.variacoes(itemPedido.variacoes).sort((a, b) => {
        if (a.indice !== b.indice) return a.indice - b.indice;
        if (a.variacao !== b.variacao) return a.variacao.localeCompare(b.variacao);
        return a.nome.localeCompare(b.nome);
      });

      variacoesOrdenadas.forEach((itemVariacao) => {
        itensPedido += `
          <tr style="width: 100%;border: none;">
            <td style="border: none;" align="right" valign="top" style="max-width: 20%"><h6 style="margin: 0;font-weight: 400;white-space: nowrap;">${itemVariacao.quantidade}x </h6></td>
            <td style="border: none;" align="left" valign="top" style="max-width: 50%"><h6 style="margin: 0;font-weight: 400;"><strong>${filters.removeAccents(itemVariacao.nome).toUpperCase()}</strong></h6></td>
          </tr>`;
      });
    }

    if (itemPedido.observacao) {
      itensPedido += `
        <tr style="width: 100%;border: none;">
          <td colspan="2" align="left" valign="middle" style="max-width: 100%; border: none;"><h6 style="margin: 0;font-weight: 400;"><strong>OBS.: </strong>${toUpper(itemPedido.observacao)}</h6></td>
        </tr>`;
    }

    if (pedido.itens.length > 1) {
      itensPedido += `<tr style="width: 100%;border: none; height: 0.1cm"><td colspan="2" style="border: none;">&nbsp;</td></tr>`;
    }
  });

  itensPedido += `</table>`;

  if (pedido.observacao && pedido.observacao.length > 0) {
    obsevacaoPedido += `
      <tr style="width: 100%">
        <td colspan="2" align="center" valign="middle" style="width: 100%; border-top: 1px solid #000000; border-bottom: 1px solid #000000;"><h5 style="margin: 0;"><strong>OBSERVACAO DO PEDIDO</strong></h5></td>
      </tr>
      <tr style="width: 100%">
        <td colspan="2" align="left" valign="middle" style="width: 100%"><h6 style="margin: 0;font-weight: 400;word-break: break-word;">${toUpper(pedido.observacao)}</h6></td>
      </tr>`;
  }

  if (tamanho && tamanho == 1 && isQz) {
    stylePequeno = `
      <head>
        <style type="text/css" media="print">
          @page { size: auto; margin: 0mm 2mm 0mm 0mm; }
          body { margin: 0mm; padding: 0mm; box-sizing: border-box; }
          body, table { font-family: Consolas, sans-serif; font-weight: 400; width: 72mm; font-size: 13px!important; }
          tr, td { border: 0.3px solid #FFFFFF; }
        </style>
        <style type="text/css">
          body, table tbody { font-size: small!important; }
        </style>
      </head>`;
  } else if (tamanho && tamanho == 2 && isQz) {
    stylePequeno = `
      <head>
        <style type="text/css" media="print">
          @page { size: auto; margin: 0mm 2mm 2mm 0mm; }
          body { margin: 0mm; padding: 0mm; box-sizing: border-box; }
          body, table { font-family: Consolas, sans-serif; width: 72mm; font-size: 14pxpx!important; }
          tr, td { border: 0.3px solid #FFFFFF; }
        </style>
      </head>`;
  } else {
    stylePequeno = `
      <head>
        <style type="text/css" media="print">
          h6 { font-size: 13px; font-weight: 500!important; }
          @page { size: auto; margin: 0mm 0mm 0mm 0mm; }
          body { margin: 0mm; padding: 0mm; box-sizing: border-box; }
          body, table { font-family: Consolas, sans-serif; font-weight: 500; width: 72mm; }
        </style>
      </head>`;
  }

  const html = `
    <html style="font-family: Consolas; font-weight: 400;">
      ${stylePequeno}
      <table style="width: 100%;" border="0">
        <tr style="width: 100%; height: auto;">
          <td colspan="2" align="center" valign="middle"><h2 style="margin: 0; padding: 0;">BIGOU DELIVERY</h2></td>
        </tr>
        <tr style="width: 100%">
          <td colspan="2" align="left" valign="middle" style="width: 100%"><h6 style="margin: 0;font-weight: 400;"><b>PEDIDO: ${pedido.id}</strong></h6></td>
        </tr>
        <tr style="width: 100%">
          <td colspan="2" align="left" valign="middle" style="width: 100%"><h6 style="margin: 0;font-weight: 400;word-break: break-word;"><strong>CLIENTE: </strong>${toUpper(pedido.usuario.nome)}</h6></td>
        </tr>
        <tr style="width: 100%; height: auto;">
          <td colspan="2" align="center" valign="middle" style="width: 100%; border-top: 1px solid #000000; border-bottom: 1px solid #000000;"><h5 style="margin: 0;"><strong>ITENS DO PEDIDO</strong></h5></td>
        </tr>
      </table>
      ${itensPedido}
      <table style="width: 100%;" border="0">
        ${obsevacaoPedido}
        <tr style="width: 100%; border-bottom: 1px solid #000000;"><td colspan="3">&nbsp</td></tr>
        <tr style="width: 100%">
          <td colspan="3" align="center" valign="middle" style="width: 100%;"><h5 style="margin: 0;"><strong>CUPOM NAO FISCAL</strong></h5></td>
        </tr>
        <tr style="width: 100%">
          <td colspan="3" align="center" valign="middle" style="width: 100%;"><h5>${isCardapioDigital ? '' : 'www.bigou.com.br'}</h5></td>
        </tr>
        <tr style="width: 100%"><td colspan="3">&nbsp</td></tr>
      </table>
    </html>`;

  return html;
};

exports.printPadrao = async function(pedido, vm, window, document, tab) {
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;
  const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
  const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

  const left = ((width / 2) - (480 / 2)) + dualScreenLeft;
  const top = ((height / 2) - (320 / 2)) + dualScreenTop;

  if (!tab || !printWindow || printWindow.closed) {
    printWindow = window.open('', tab ? '_blank' : 'PRINT', `height=320,width=480,top=${top},left=${left}`);
  } else if (tab) {
    printWindow.document.open();
  }

  const mywindow = printWindow;

  this.isQz = false;

  try {
    const htmlContent = await this.impressaoCompleta(pedido, vm);
    mywindow.document.write(htmlContent);
    mywindow.document.close();
    mywindow.focus();
    mywindow.print();
    if (!tab) {
      setTimeout(function() { mywindow.close(); }, 100);
    }
  } catch (error) {
    console.error('Error during print:', error);
    mywindow.close();
  }

  return true;
};

exports.printNovo = async function(pedido, vm, window, document, tab) {
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;
  const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
  const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

  const left = ((width / 2) - (480 / 2)) + dualScreenLeft;
  const top = ((height / 2) - (320 / 2)) + dualScreenTop;

  if (!tab || !printWindow || printWindow.closed) {
    printWindow = window.open('', tab ? '_blank' : 'PRINT', `height=320,width=480,top=${top},left=${left}`);
  } else if (tab) {
    printWindow.document.open();
  }

  const mywindow = printWindow;

  this.isQz = false;

  try {
    const htmlContent = await this.impressaoLimpa(pedido, vm);
    mywindow.document.write(htmlContent);
    mywindow.document.close();
    mywindow.focus();
    mywindow.print();
    if (!tab) {
      setTimeout(function() { mywindow.close(); }, 100);
    }
  } catch (error) {
    console.error('Error during print:', error);
    mywindow.close();
  }

  return true;
};

exports.printSimplificado = async function(pedido, vm, window, document, tab) {
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;
  const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
  const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

  const left = ((width / 2) - (480 / 2)) + dualScreenLeft;
  const top = ((height / 2) - (320 / 2)) + dualScreenTop;

  if (!tab || !printWindow || printWindow.closed) {
    printWindow = window.open('', tab ? '_blank' : 'PRINT', `height=320,width=480,top=${top},left=${left}`);
  } else if (tab) {
    printWindow.document.open();
  }

  const mywindow = printWindow;

  this.isQz = false;

  try {
    const htmlContent = await this.impressaoSimplificada(pedido, vm);
    mywindow.document.write(htmlContent);
    mywindow.document.close();
    mywindow.focus();
    mywindow.print();
    if (!tab) {
      setTimeout(function() { mywindow.close(); }, 100);
    }
  } catch (error) {
    console.error('Error during print:', error);
    mywindow.close();
  }

  return true;
};

exports.variacoes = function(variacoes) {
  var group = _.groupBy(variacoes, 'item_catalogo_id');
  var listVariacoes = [];
  for (var i in group) {
    var variacao = group[i][0];
    var quantidade = group[i].length;
    listVariacoes.push({
      quantidade: quantidade,
      nome: variacao.item.nome,
      variacao: variacao.variacao.nome,
      preco: quantidade * variacao.preco,
      indice: variacao.item.indice_categoria || 0,
      mod_preco: variacao.mod_preco
    });
  }
  return listVariacoes;
};
